import * as Sentry from '@sentry/react';
// Add this button component to your app to test Sentry's error tracking
export default function ErrorButtonTest() {

  return (
    <button
      onClick={() => {
        throw new Error('Test error sentry');
      }}
    >
      Break the world
    </button>
  );
}